// extracted by mini-css-extract-plugin
module.exports = {"selected-week":"styles_selected-week__2ckYh"};